import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { PageNotFound } from './components/views/PageNotFound/PageNotFound';
import { Login } from './components/views/Login/Login';
import { Renovation } from './components/views/Login/Renovation';
import { ConfirmedPayment } from './components/views/Login/ConfirmedPayment';

import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import CasheaRedirect from './components/views/CasheaPopup/CasheaRedirect';
import CasheaCheckout from './components/views/CasheaPopup/CasheaCheckout';
import { EnvBanner } from './components/common/EnvBanner/EnvBanner';

function App() {
  return (
    <React.Fragment>
      <EnvBanner />
      <div className="app-content">
        <div>
          <Switch>
            <Route
              path="/confirmed-payment"
              render={props => {
                return <ConfirmedPayment {...props} props={props} />;
              }}
            />
            <Route
              path="/renew/:membershipId"
              render={props => {
                return <Renovation {...props} props={props} />;
              }}
            />
            <Route
              path="/cashea-confirmation"
              render={() => {
                return <CasheaRedirect />;
              }}
            />
            <Route
              path="/cashea-checkout"
              render={() => {
                return <CasheaCheckout />;
              }}
            />
            <Route
              path="/"
              render={props => {
                return <Login {...props} props={props} />;
              }}
            />
            <Route component={PageNotFound} />
          </Switch>
        </div>
      </div>
    </React.Fragment>
  );
}

export default App;
